(function () {
  class MessageBox extends PIXI.Container {
    constructor() {
      super();

      this._callback = undefined;

      this._pressStartBox = undefined;

      this.time = 5000;
      this.currentMessageID = 0;
      this.messages = [];
      this.numMessages = 6;
      this.currentSpin = 0;
      this.tweens = {};
    }

    onMessageSpin() {
      this.fadeElements(true, "messageBox");
      this.showLogo(false);
      if (this.currentSpin < this.numMessages) {
        this.currentSpin++;
        if (this.currentMessageID === 0) {
          this.hidePreviousMessage(4);
          this.changeMessage(this.currentMessageID);
        } else {
          this.hidePreviousMessage(this.currentMessageID);
          this.changeMessage(this.currentMessageID);
        }
      } else {
        this.currentMessageID = 0;
        this.currentSpin = 0;
        this.onMessageSpin();
      }
    }

    onSpinEnd() {
      this.showLogo(true);
      if (this.currentMessageID < this.numMessages) {
        this.hidePreviousMessage(this.currentMessageID);
        this.currentMessageID++;
        if (this.currentMessageID === this.numMessages) {
          this.currentMessageID = 0;
        }
      } else {
        this.currentMessageID = 0;
        for (let i = 0; i < this.numMessages; i++) {
          this.hidePreviousMessage(i);
        }
      }
    }

    fadeElements(isFadeIn, ...ids) {
      ids.forEach((id) => {
        this.tweens?.[id]?.kill();
        const element = resourceManager.get(id);

        if (isFadeIn) {
          element.visible = true;
          this.tweens[id] = gsap.to(element, {
            alpha: 1,
            duration: 0.2,
          });
        } else {
          this.tweens[id] = gsap.to(element, {
            alpha: 0,
            duration: 0.2,
            onComplete: () => {
              element.visible = false;
            },
          });
        }
      });
    }

    showLogo(show) {
      switch (layoutController.getCurrentLayout()) {
        case "landscape_default":
        case "landscape_mobile": {
          this.fadeElements(!show, "messageBox");
          if (!show) {
            this.fadeElements(
              false,
              "logoWolfRun",
              "logoFSWolfRun",
              "logoFreeSpins",
              "logoPortrait",
              "logo",
              "slotContainer:cashLinkFeatureContainer:cashLinkFeature:CashLinkLogo"
            );
          } else if (
            !gameController.inFreeSpins &&
            !gameController.isInWolfRun &&
            !gameController.inCashLink
          ) {
            this.fadeElements(
              false,
              "logoWolfRun",
              "logoFSWolfRun",
              "logoFreeSpins",
              "logoPortrait",
              "slotContainer:cashLinkFeatureContainer:cashLinkFeature:CashLinkLogo"
            );
            this.fadeElements(true, "logo");
          } else if (gameController.inCashLink) {
            this.fadeElements(
              false,
              "logoWolfRun",
              "logoFSWolfRun",
              "logoFreeSpins",
              "logoPortrait",
              "logo"
            );
            this.fadeElements(
              true,
              "slotContainer:cashLinkFeatureContainer:cashLinkFeature:CashLinkLogo"
            );
          } else if (gameController.isInWolfRun) {
            this.fadeElements(!gameController.inFreeSpins, "logoWolfRun");
            this.fadeElements(gameController.inFreeSpins, "logoFSWolfRun");
            this.fadeElements(
              false,
              "logoFreeSpins",
              "logoPortrait",
              "logo",
              "slotContainer:cashLinkFeatureContainer:cashLinkFeature:CashLinkLogo"
            );
          } else if (gameController.inFreeSpins) {
            this.fadeElements(
              false,
              "logoWolfRun",
              "logoFSWolfRun",
              "logoPortrait",
              "logo",
              "slotContainer:cashLinkFeatureContainer:cashLinkFeature:CashLinkLogo"
            );
            this.fadeElements(true, "logoFreeSpins");
          }
          break;
        }
        case "portrait_default":
        case "portrait_mobile":
        default: {
          this.fadeElements(true, "messageBox");
          if (
            !gameController.inFreeSpins &&
            !gameController.isInWolfRun &&
            !gameController.inCashLink
          ) {
            this.fadeElements(
              false,
              "logoWolfRun",
              "logoFSWolfRun",
              "logoFreeSpins",
              "logo",
              "slotContainer:cashLinkFeatureContainer:cashLinkFeature:CashLinkLogo"
            );
            this.fadeElements(true, "logoPortrait");
          } else if (gameController.isInWolfRun) {
            if (gameController.inFreeSpins) {
              this.fadeElements(false, "logoWolfRun");
              this.fadeElements(true, "logoFSWolfRun", "logoFreeSpins");
            } else {
              this.fadeElements(true, "logoWolfRun");
              this.fadeElements(false, "logoFSWolfRun");
            }
            this.fadeElements(
              false,
              "logoFreeSpins",
              "logoPortrait",
              "logo",
              "slotContainer:cashLinkFeatureContainer:cashLinkFeature:CashLinkLogo"
            );
          } else if (gameController.inCashLink) {
            this.fadeElements(
              false,
              "logoFreeSpins",
              "messageBox",
              "logoWolfRun",
              "logoFSWolfRun",
              "logoPortrait",
              "logo"
            );
            this.fadeElements(
              true,
              "slotContainer:cashLinkFeatureContainer:cashLinkFeature:CashLinkLogo"
            );
            if (gameController.inFreeSpins) {
              this.fadeElements(true, "logoFreeSpins");
            }
            if (gameController.inFreeSpins && gameController.inCashLink) {
              this.fadeElements(false, "logoFreeSpins");
            }
          } else if (gameController.inFreeSpins) {
            this.fadeElements(
              false,
              "logoWolfRun",
              "logoFSWolfRun",
              "logoPortrait",
              "logo",
              "slotContainer:cashLinkFeatureContainer:cashLinkFeature:CashLinkLogo"
            );
            this.fadeElements(true, "logoFreeSpins");
          }
          break;
        }
      }
    }

    hidePreviousMessage(msgID) {
      resourceManager.get(
        `messageBox:messageBox:message${msgID}`
      ).visible = false;
    }

    changeMessage(msgID) {
      resourceManager.get(
        `messageBox:messageBox:message${msgID}`
      ).visible = true;
    }
  }

  let MessageBoxIntroCreator = function () {
    return new MessageBox();
  };

  let MessageBoxIntroInitialiser = function () {};

  let MessageBoxIntroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "MessageBox",
    MessageBoxIntroCreator,
    MessageBoxIntroInitialiser,
    MessageBoxIntroFilesRequired
  );
})();
